module.exports = __webpack_public_path__ + "static/augsburger_allgemeine_logo-e069c5ea6b75920ca5fe0182117b9fd9.webp";